<rma-navigation-header redirectUrl="/manage-account/billing" />

<ng-container *transloco="let t; prefix: 'subscriptions.billing.pauseSubscription'">
  <mat-card class="mx-auto my-20 w-full max-w-2xl p-10">
    <h1 class="text-heading-2">{{ t('heading') }}</h1>
    <img alt="" class="mx-auto mb-6 mt-4" [src]="'dashboard/illustrations/offer-pause-img.png' | staticImageUrl" width="300" />
    <div class="rounded-md border border-steel-20 p-6">
      <div class="flex flex-col gap-6">
        <p [innerHTML]="t('description')"></p>
        <p [innerHTML]="t('whatHappens.question')"></p>
        <div class="flex items-center gap-2">
          <rma-icon glyph="check" theme="primary" />
          <p>{{ t('whatHappens.first') }}</p>
        </div>
        <div class="flex items-center gap-2">
          <rma-icon glyph="pause_circle" theme="warning" />
          <p>{{ t('whatHappens.second') }}</p>
        </div>
      </div>
      <div class="text-center">
        <a type="button" class="mt-6" [routerLink]="'/billing/confirm-pause'" mat-stroked-button color="primary">{{
          t('pause.button.text')
        }}</a>
      </div>
    </div>

    <div class="flex justify-between pt-6">
      <a routerLink="/manage-account/billing" color="primary" mat-button>{{ t('cancel') }}</a>
      <a mat-flat-button color="primary" routerLink="/billing/unsubscribe-confirm">{{ t('downgrade') }}</a>
    </div>
  </mat-card>
</ng-container>
